module.exports = __webpack_public_path__ + "img/mauritius.45805143.svg";